import { FETCH_NOTIFICATIONS, FETCH_NOTIFICATIONS_SUCCESS, FETCH_NOTIFICATIONS_FAILURE } from '../actions';

const initialState = {
  notifications: [],
  loading: true,
  err: null,
  haveData: false
};

export const reducer = (state = initialState, action) => {
  switch(action.type) {
    case FETCH_NOTIFICATIONS:
      return {
        ...state,
        loading: true,
        err: null,
        haveData: false
      };
    case FETCH_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        loading: false,   
        haveData: true,     
        notifications: action.data
      };
    case FETCH_NOTIFICATIONS_FAILURE:
      return {
        ...state,
        loading: false,
        haveData: false,
        err: action.error,
        notifications: []
      };
    default:
      return state;
  }
}